<template>
    <div class="traceability-contract-view-page">
        <base-header :class="contractId ? 'modal-view-contract' : ''" :titulo="translate('messages.view_title')" :voltarPara='true' />
        <div class="view-container-wrapper">
            <div class="content">
                <contract-data />
                <properties-volume />
                <properties-list />
                <div
                    class="actions"
                    v-if="isApprover && isContractOwner && report.status === 'ENVIADO'"
                >
                    <el-button @click="reprove()"
                        >{{ translate('words.reprove') }}
                    </el-button>
                    <el-button @click="approve()" type="primary"
                        >{{ translate('words.approve') }}
                    </el-button>
                </div>
            </div>
        </div>
        <dialog-reprove
            v-if="dialogReproveVisible"
            v-model="dialogReproveVisible"
        />
    </div>
</template>

<script>
import BaseHeader from '@/components/BaseHeader.vue';
import ContractData from '@/modules/traceability-contract/views/pages/view/components/contract-data/index.vue';
import PropertiesVolume from '@/modules/traceability-contract/views/pages/view/components/properties-volume/index.vue';
import PropertiesList from '@/modules/traceability-contract/views/pages/view/components/properties-list/index.vue';
import { mapActions, mapGetters } from 'vuex';
import DialogReprove from '@/modules/traceability-contract/views/pages/view/components/dialog-reprove/index.vue';

export default {
    name: 'ViewPage',
    components: {
        DialogReprove,
        BaseHeader,
        ContractData,
        PropertiesVolume,
        PropertiesList
    },
    data() {
        return {
            dialogReproveVisible: false
        };
    },
    props: {
        contractId: {
            type: Number,
            default: null
        }
    },
    // TODO (Leandro Campolina) : revisar este código, passar a implementação para o módulo traceability-report
    created() {
        if (this.contractId) {
            this.viewTraceabilityReport(this.contractId);
        } else {
            const params = this.$route.params;
            this.viewTraceabilityReport(params.id);
        }
    },
    beforeDestroy() {
        this.$store.commit('traceabilityContractModule/SET_PROPERTIES', []);
    },
    computed: {
        ...mapGetters('traceabilityContractModule', {
            isRegistrant: 'isRegistrant',
            isApprover: 'isApprover',
            isContractOwner: 'isContractOwner',
            report: 'getReport'
        })
    },
    methods: {
        ...mapActions('traceabilityContractModule', [
            'viewTraceabilityReport',
            'reportApprove',
            'reportReprove'
        ]),
        translate(key, params = {}) {
            const base = 'contrato_rastreabilidade';
            return this.$t(`${base}.${key}`, params);
        },
        reprove() {
            this.$messageBox
                .confirm(
                    this.translate('messages.dialog_reprove.message'),
                    this.translate('messages.dialog_reprove.title'),
                    {
                        confirmButtonText: this.translate(
                            'messages.dialog_reprove.confirm'
                        ),
                        cancelButtonText: this.translate('words.cancel'),
                        type: 'warning'
                    }
                )
                .then(() => {
                    this.dialogReproveVisible = true;
                })
                .catch(() => {});
        },
        approve() {
            this.$messageBox
                .confirm(
                    this.translate('messages.dialog_approve.message'),
                    this.translate('messages.dialog_approve.title'),
                    {
                        confirmButtonText: this.translate(
                            'messages.dialog_approve.confirm'
                        ),
                        cancelButtonText: this.translate('words.cancel'),
                        type: 'warning'
                    }
                )
                .then(() => {
                    this.reportApprove(this.$route.params.id)
                        .then(() => {
                            this.$notify.success(
                                this.translate(
                                    'messages.dialog_approve.approved_successfully'
                                )
                            );
                            this.$router.push({
                                name: 'contrato-rastreabilidade-comprador'
                            });
                        })
                        .catch(() => {
                            this.$notify.error(
                                this.translate(
                                    'messages.dialog_approve.approved_error'
                                )
                            );
                        });
                })
                .catch(() => {});
        }
    }
};
</script>

<style scoped lang="scss">
.traceability-contract-view-page {
    .view-container-wrapper {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
    }

    .content {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding: 16px;
    }

    .actions {
        display: flex;
        justify-content: flex-end;
        gap: 16px;
    }

    .modal-view-contract {
        margin: 0 17px;
    }
}
</style>
